import type { ProjectStatus } from '@/features/publicsite/types/research/ProjectStatus';
import type { PublicCatalogKey } from '@/i18n/dictionaries/publicCatalog';

/** The two statuses the public research endpoints answer with — the union is ProjectStatus. */
export const PROJECT_STATUS = {
  ongoing: 'ONGOING',
  completed: 'COMPLETED',
} as const;

/** Whether a status from the server is one this file names — see projectStatusLabel. */
export function isProjectStatus(code: string): code is ProjectStatus {
  return Object.values<string>(PROJECT_STATUS).includes(code);
}

const STATUS_KEY: Record<ProjectStatus, PublicCatalogKey> = {
  ONGOING: 'projectStatusONGOING',
  COMPLETED: 'projectStatusCOMPLETED',
};

/**
 * The label for a research project's status, never the enum itself.
 *
 * The public catalogue printed `ONGOING` on the card and, once it existed, on the project page —
 * the same defect the home calendar had with event kinds, which public-site-home-layout guards
 * against by asserting no SCREAMING_SNAKE reaches the screen. The cabinet already names these two
 * states ("În derulare" / "Finalizat"); the public site was showing the reader the database value.
 *
 * Guarded rather than interpolated straight into `t()`, because useTranslation answers a missing
 * key with the key itself: a third status added server-side would put the literal text
 * "projectStatusARCHIVED" on the page. Falling back to the raw value keeps that case no worse
 * than it is today, which is the right direction for something nobody will notice until it ships.
 */
export function projectStatusLabel(
  t: (key: PublicCatalogKey, vars?: Record<string, string | number>) => string,
  status: string,
): string {
  return isProjectStatus(status) ? t(STATUS_KEY[status]) : status;
}
